import {Box, Button, Snackbar, Stack} from "@mui/material";
import LoadingScreen from "../../components/LoadingScreen";
import CustomTable from "../../components/TableColumnShapes/CustomTable";
import React, {FC, useEffect, useState} from "react";
import {ColumnActionProps} from "../../types/ColumnActionProps";
import {useAppSelector} from "../../hooks/useRedux";
import useTitle from "../../hooks/useTitle";
import {getTrips} from "../../api/trip";
import TripListColumnShape from "../../components/TableColumnShapes/TripListColumnShape";
import {ITrip} from "../../types/Trip";
import updateQueryParams from "../../utils/updateQueryParams";
import StyledPagination from "../../components/StyledPagination";
import {useSearchParams} from "react-router-dom";
import DeleteRoleDialog from "../roles/DeleteRoleDialog";
import DeleteTripDialog from "./DeleteTripDialog";
import {Alert} from "@mui/lab";

const TripsPage: FC = () => {
    useTitle("Courses")
    const [trips, setTrips] = useState<ITrip[]>([])
    const searchParams = useSearchParams()[0]
    const [dataCount, setDataCount] = useState<number>(0)
    const [deleteTripDialogOpen, setDeleteTripDialogOpen] = useState(false)
    const [showRoleActionResultFeedback, setShowRoleActionResultFeedback] = useState(false)
    const [actionResult, setActionResult] = useState<{ status: "success" | "error", message?: string }>()
    const [currentTrip, setCurrentTrip] = useState<ITrip | null>(null)
    const [loadingData, setLoadingData] = useState(false)
    const loadData = () => {
        setLoadingData(true)
        getTrips(parseInt(searchParams.get("page") || "1"))
            .then(value => {
                setLoadingData(false)
                setTrips(value.data)
                setDataCount(value.count)
            }).catch(() => {
            setLoadingData(false)
        })
    }
    const columnActionProps: ColumnActionProps<ITrip> = {
        onDeleteAction: (item) => {
            setCurrentTrip(item)
            setDeleteTripDialogOpen(true)
        }
    }


    const handleSnackbarClose = () => {
        setShowRoleActionResultFeedback(false)
    }


    useEffect(() => {
        loadData()
    }, [])

    return (<Box pt={2} pb={4}>
            {loadingData ? <LoadingScreen/> :
                <Stack width={"100%"} gap={1} alignItems={"center"}>
                    <CustomTable columnShape={TripListColumnShape(columnActionProps)} data={trips}/>

                    <StyledPagination variant={"outlined"} page={parseInt(searchParams.get("page")) || 1}
                                      count={Math.ceil(dataCount / 15)}
                                      onChange={(event, p) => updateQueryParams("page", [p.toString()])}
                                      size={"large"}/>
                </Stack>}

            <DeleteTripDialog
                onClose={() => {
                    setDeleteTripDialogOpen(false)
                }} target={currentTrip}
                open={deleteTripDialogOpen}
                onEntityActionStatusChange={(status, message) => {
                    if (status === "success")
                        loadData()

                    setActionResult({
                        status,
                        message
                    })
                    setShowRoleActionResultFeedback(true)
                    setCurrentTrip(null)
                }}/>

            <Snackbar open={showRoleActionResultFeedback} autoHideDuration={6000} onClose={handleSnackbarClose}>
                <Alert
                    onClose={handleSnackbarClose}
                    severity={actionResult?.status}
                    variant="filled"
                    sx={{width: '100%'}}>
                    {actionResult?.message}
                </Alert>
            </Snackbar>
        </Box>
    )

}

export default TripsPage